"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _callout = _interopRequireDefault(require("../callout"));

var _codeEditor = _interopRequireDefault(require("../code-editor"));

var _formLabel = _interopRequireDefault(require("../../styles-common/form-label"));

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

var _helpers = require("./helpers");

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AdvancedEditor = function AdvancedEditor(_ref) {
  var themeColor = _ref.themeColor,
      advanced = _ref.advanced,
      isEditing = _ref.isEditing,
      isWidgetAdvanced = _ref.isWidgetAdvanced,
      serializedWidgetConfig = _ref.serializedWidgetConfig,
      setEditor = _ref.setEditor,
      setWidgetConfig = _ref.setWidgetConfig,
      patchConfiguration = _ref.patchConfiguration;
  var stringifiedWidgetConfig = (0, _react.useMemo)(function () {
    return JSON.stringify(serializedWidgetConfig, null, 2);
  }, [serializedWidgetConfig]);

  var _ref2 = (0, _react.useState)(advanced ? stringifiedWidgetConfig : ''),
      _ref3 = _slicedToArray(_ref2, 2),
      editorValue = _ref3[0],
      setEditorValue = _ref3[1];

  var _ref4 = (0, _react.useState)(advanced ? (0, _helpers.getValidationErrors)(serializedWidgetConfig) : []),
      _ref5 = _slicedToArray(_ref4, 2),
      validationErrors = _ref5[0],
      setValidationErrors = _ref5[1];

  var onSwitchToAdvancedMode = (0, _react.useCallback)(function () {
    var json = JSON.parse(stringifiedWidgetConfig);

    if (json.config) {
      json.config.name = 'user-custom';
    }

    if (json.paramsConfig) {
      delete json.paramsConfig;
    }

    if (json.we_meta) {
      delete json.we_meta;
    }

    var config = JSON.stringify(json, null, 2);
    setEditor({
      advanced: true
    });
    setWidgetConfig(JSON.parse(config));
    setEditorValue(config);
    patchConfiguration();
  }, [stringifiedWidgetConfig, setEditor, setWidgetConfig, patchConfiguration]);
  var onSwitchToInteractiveMode = (0, _react.useCallback)(function () {
    setEditor({
      advanced: false
    });
    setValidationErrors([]);
    setTimeout(function () {
      return patchConfiguration();
    }, 0);
  }, [setEditor, patchConfiguration]);
  var validateAndUpdateStore = (0, _react.useCallback)((0, _debounce["default"])(function (value) {
    try {
      var json = JSON.parse(value);
      var errors = (0, _helpers.getValidationErrors)(json);

      if (errors.length) {
        setValidationErrors(errors);
      } else {
        setValidationErrors([]);
        setWidgetConfig(json);
        patchConfiguration();
      }
    } catch (e) {
      setValidationErrors(['Cannot parse into a JSON file']);
    }
  }, 1500), [setWidgetConfig, setValidationErrors, patchConfiguration]);
  var onChange = (0, _react.useCallback)(function (value) {
    setEditorValue(value);
    validateAndUpdateStore(value);
  }, [validateAndUpdateStore, setEditorValue]);
  (0, _react.useEffect)(function () {
    if (!advanced) {
      setEditorValue(stringifiedWidgetConfig);
    }
  }, [advanced, stringifiedWidgetConfig, setEditorValue]);
  return _react["default"].createElement(_style.Container, null, !advanced && _react["default"].createElement(_callout["default"], null, _react["default"].createElement("p", null, "The advanced mode is intended for experienced users who want to create or edit a widget using code instead of the interactive interface."), _react["default"].createElement("p", null, "Once activated, you ", _react["default"].createElement("strong", null, "may not"), " use the interactive interface anymore."), _react["default"].createElement("p", null, _react["default"].createElement(_style.CalloutButton, {
    size: "small",
    btnType: "highlight",
    onClick: onSwitchToAdvancedMode
  }, "Switch to the advanced mode"))), advanced && (!isEditing || !isWidgetAdvanced) && _react["default"].createElement(_callout["default"], null, _react["default"].createElement("p", null, "You are using the advanced mode."), _react["default"].createElement("p", null, "To go back to the interactive mode,", ' ', _react["default"].createElement(_style.CalloutLinkButton, {
    themeColor: themeColor,
    onClick: onSwitchToInteractiveMode
  }, "click here"), ". ", _react["default"].createElement("strong", null, "All your code changes will be lost."))), advanced && _react["default"].createElement(_style.InfoCallout, null, _react["default"].createElement("p", null, "Advanced widgets follow the", ' ', _react["default"].createElement("a", {
    href: "https://vega.github.io/vega/docs/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Vega specification"), ". The widget editor supports any properties of Vega 5.9 and below."), _react["default"].createElement("p", null, "Some parts of the editor's generated Vega JSON use custom formats. This applies to the tooltip and legend. To learn more about these, please have a look at this", ' ', _react["default"].createElement("a", {
    href: "https://github.com/Vizzuality/widget-editor/wiki/Widgets'-specification",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "reference document"), ".")), advanced && validationErrors.length > 0 && _react["default"].createElement(_style.ValidationCallout, null, _react["default"].createElement("p", null, "The Vega JSON is invalid:"), _react["default"].createElement("ul", null, validationErrors.map(function (error) {
    return _react["default"].createElement("li", {
      key: error
    }, error);
  }))), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "advanced-textarea"
  }, "Vega JSON"), _react["default"].createElement(_codeEditor["default"], {
    id: "advanced-textarea",
    value: editorValue,
    onChange: advanced ? onChange : undefined,
    invalid: validationErrors.length > 0,
    disabled: !advanced
  })));
};

AdvancedEditor.propTypes = {
  themeColor: _propTypes["default"].string.isRequired,
  advanced: _propTypes["default"].bool.isRequired,
  isEditing: _propTypes["default"].bool.isRequired,
  isWidgetAdvanced: _propTypes["default"].bool.isRequired,
  serializedWidgetConfig: _propTypes["default"].object,
  setEditor: _propTypes["default"].func.isRequired,
  setWidgetConfig: _propTypes["default"].func.isRequired,
  patchConfiguration: _propTypes["default"].func.isRequired
};
AdvancedEditor.defaultProps = {
  serializedWidgetConfig: null
};
var _default = AdvancedEditor;
exports["default"] = _default;